import React from 'react';
import { Droppable } from '@hello-pangea/dnd';
import TaskCard from './TaskCard';
import { FaPlus } from 'react-icons/fa';
import { useProject } from '../../context/ProjectContext';
import todoIcon from '../../assets/todo.svg';
import inProgressIcon from '../../assets/in-prog.svg';
import holdIcon from '../../assets/hold.svg';
import reopenedIcon from '../../assets/status-reopen.svg';
import completedIcon from '../../assets/completed.svg';

const BoardColumn = ({ id, title, tasks: initialTasks, onStatusChange, onTaskClick, onShowTaskDetails, onEditTask, onDeleteTask, onCreateTask, onCreateSubtask, onOpenChat, onOpenUploadDocs, statusClass }) => {
    const { activeProject } = useProject(); // Fetch activeProject directly
    // We'll use initialTasks directly as they are already filtered by status and other filters in ProjectTaskList
    const localTasks = initialTasks;

    return (
        <div className={`board-column ${statusClass}`}>
            <div className="board-column-header">
                <div className="column-title-container">
                    <span className="column-status-badge">
                        {title === 'To Do' && <img src={todoIcon} alt="" className="column-status-icon" />}
                        {title === 'In Progress' && <img src={inProgressIcon} alt="" className="column-status-icon" />}
                        {title === 'Hold' && <img src={holdIcon} alt="" className="column-status-icon" />}
                        {title === 'Reopened' && <img src={reopenedIcon} alt="" className="column-status-icon" />}
                        {title === 'Completed' && <img src={completedIcon} alt="" className="column-status-icon" />}
                        {title}
                    </span>
                    <span className="column-task-count">{localTasks.length}</span>
                </div>
            </div>

            <Droppable droppableId={id}>
                {(provided, snapshot) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        className={`board-task-list ${snapshot.isDraggingOver ? 'dragging-over' : ''}`}
                    >
                        {localTasks.map((task, index) => (
                            <TaskCard
                                key={task.id}
                                task={task}
                                index={index}
                                onStatusChange={onStatusChange}
                                onClick={onTaskClick}
                                onShowTaskDetails={onShowTaskDetails}
                                onEditTask={onEditTask}
                                onDeleteTask={onDeleteTask}
                                onCreateSubtask={onCreateSubtask}
                                onOpenChat={onOpenChat}
                                onOpenUploadDocs={onOpenUploadDocs}
                            />
                        ))}
                        {provided.placeholder}
                        {localTasks.length === 0 && (
                            <div className="column-empty-label">No tasks found</div>
                        )}
                    </div>
                )}
            </Droppable>

            {activeProject?.permissions?.can_create_tasks && (
                <button
                    className="column-create-btn"
                    onClick={() => onCreateTask(id)}
                >
                    <FaPlus size={12} />
                    <span>Create</span>
                </button>
            )}
        </div>
    );
};

export default BoardColumn;
